import { gql } from '@apollo/client';

export const GET_SURVEY_ACTIVITIES = gql(/* GraphQL */ `
    query GetSurveyActivities($surveyId: String!) {
        getSurveyActivities(surveyId: $surveyId) {
            id
            type
            description
            isSystemGenerated
            metadata {
                zoneName
                competitorId
                competitorName
                sku
                skus
                count
                itemCount
            }
            createdAt
            user {
                firstName
                lastName
            }
        }
    }
`);
